// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__yunXS","iconContainer":"Footer_iconContainer__earF2","paragraphText":"Footer_paragraphText__88lge"};